import script from "./ArtistMemberStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./ArtistMemberStatistics.vue?vue&type=script&setup=true&lang=js"

import "./ArtistMemberStatistics.vue?vue&type=style&index=0&id=9849da8a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9849da8a"]])

export default __exports__